import React, { useState, useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import SETTINGS from '../../SETTINGS';
import { getSubdomain } from '../../utils/utils';
import { setClarityConsent } from '../../utils/clarity';
import './CookieBanner.css';

const CookieBanner = () => {
    const [showBanner, setShowBanner] = useState(false);
    const [showInfo, setShowInfo] = useState(false);
    const posthog = usePostHog();
    const colla = getSubdomain();
    const collaColor = SETTINGS(colla).color;

    useEffect(() => {
        const consent = localStorage.getItem('cookie-consent');
        if (!consent) {
            setShowBanner(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie-consent', 'accepted');
        setShowBanner(false);
        if (posthog) {
            posthog.opt_in_capturing();
        }
        setClarityConsent(true);
    };

    const handleDecline = () => {
        localStorage.setItem('cookie-consent', 'declined');
        setShowBanner(false);
        if (posthog) {
            posthog.opt_out_capturing();
        }
        setClarityConsent(false);
    };

    if (!showBanner) return null;

    return (
        <div className="cookie-banner">
            <div className="cookie-banner-content">
                <div className="cookie-banner-text">
                    <p>
                        Utilitzem cookies per fer recerca de com s'utilitza l'Aleta i millorar l'experiència d'usuari.
                        Pots acceptar-les o declinar-les.
                        {' '}
                        <span 
                            className="cookie-banner-info-link"
                            onClick={() => setShowInfo(!showInfo)}
                        >
                            Més informació +
                        </span>
                    </p>
                    {showInfo && (
                        <div className="cookie-banner-info">
                            <p>
                                Us proposem participar en un estudi de rellevància de les diferents parts de la web 
                                per entendre millor com els usuaris interactuen amb l'Aleta. Registrem només 
                                quins botons es cliquen més, quins són els patrons d'ús més habituals i quines 
                                seccions són més utilitzades.
                            </p>
                            <p>
                                No recollim cap informació personal, sensible o venuda. Es tracta únicament 
                                d'analitzar els patrons d'interacció per millorar l'experiència d'usuari.
                            </p>
                            <p>
                                Els resultats seran transparents i es reflectiran en parts de la web millorades, 
                                una interfície més intuïtiva i en general fer l'Aleta més senzilla pels futurs usuaris.
                            </p>
                        </div>
                    )}
                </div>
                <div className="cookie-banner-buttons">
                    <button 
                        className="cookie-banner-btn cookie-banner-btn-decline"
                        onClick={handleDecline}
                    >
                        Declinar
                    </button>
                    <button 
                        className="cookie-banner-btn cookie-banner-btn-accept"
                        onClick={handleAccept}
                        style={{ backgroundColor: collaColor }}
                    >
                        Acceptar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;